import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { firstValueFrom } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { AuthenticationService } from 'src/app/shared/services';
import { BankDto } from 'src/app/domain/models/dto/bank.dto';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { countries } from 'src/app/shared/utils/countries';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { GenerateInvoiceOutboundDto } from 'src/app/domain/models/dto/generate-invoice-outbound.dto';
import { NotifierService } from 'angular-notifier';
import { GenerateInvoiceSuccessModalComponent } from 'src/app/pages/orders/shared/components/modals/generate-invoice-success-modal/generate-invoice-success-modal.component';
import { NewOrderModalOutboundComponent } from '../new-order-modal-outbound/new-order-modal-outbound.component';
import { AttachInvoiceModalComponent } from 'src/app/pages/orders/shared/components/modals/attach-invoice-modal/attach-invoice-modal.component';

declare const $: any;

@Component({
  selector: 'app-generate-invoice-third-party',
  templateUrl: './generate-invoice-third-party.component.html',
  styleUrls: ['./generate-invoice-third-party.component.scss'],
})
export class GenerateInvoiceThirdPartyComponent implements OnInit {
  loading: boolean;
  companyId: number;
  orderForm: FormGroup;
  private readonly notifier: NotifierService;
  company: CorporateAccountDto;
  bankAccounts: BankAccountDto[];
  boobleModalData: any;
  branchs: string[];
  IBAN: boolean = true;
  banks: BankDto[] = [];
  countries: CountryDto[];

  controlReceiverBankName: string = '.js-control-receiver-bank-name';
  controlReceiverCountry: string = '.js-control-receiver-country';
  controlCurrency: string = '.js-control-currency';
  controlSenderBranch: string = '.js-control-sender-branch';
  controlSenderBankName: string = '.js-control-sender-bank-name';

  moedas = Moedas;

  get orderFormControl() {
    return this.orderForm.controls;
  }

  get order(): any {
    const order = this.orderForm.value;
    return order;
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private readonly authService: AuthenticationService,
    private readonly ordersService: OrdersService,
    private readonly companyService: CorporateAccountService,
    private readonly bankAccountService: BankAccountService,
    private modalService: BoobleModalService
  ) {
    this.countries = countries;
    this.companyId = +this.authService.getCompanyId();
    this.notifier = notifierService;

    this.orderForm = fb.group({
      description: [''],
      currency: [null, Validators.required],
      amount: ['', Validators.required],
      finalityId: [null, Validators.required],
      corporateAccountId: ['', Validators.required],
      senderBranch: ['', Validators.required],
      senderBankName: ['', Validators.required],
      senderBankAgency: ['', Validators.required],
      senderBankAccount: ['', Validators.required],
      receiverPersonType: [0, Validators.required],
      receiverIntermediaryAccount: [''],
      receiverIntermediaryBank: [''],
      receiverIntermediarySwift: [''],
      receiverBankChannel: [''],
      receiverAddress: [''],
      receiverABA: [''],
      receiverIBAN: [''],
      receiverName: ['', Validators.required],
      receiverBankName: [null, Validators.required],
      receiverCountry: [null, Validators.required],
      receiverAccount: ['', Validators.required],
      receiverSwift: ['', Validators.required],
      receiverSameUser: [false, Validators.required],
    });
  }

  ngOnInit() {
    this.setControls();

    firstValueFrom(this.bankAccountService.getBanks()).then(
      (value) => (this.banks = value.data)
    );

    this.orderForm.controls['corporateAccountId'].patchValue(this.companyId);
    this.orderForm.controls['finalityId'].patchValue(
      this.boobleModalData.finalityId
    );

    this.companyService.get().subscribe((getResult) => {
      this.company = getResult.data;
      this.bankAccounts = [getResult.data.bankAccount];
      this.orderForm.controls['senderBankAccount'].patchValue(
        this.bankAccounts[0].number
      );
      this.orderForm.controls['senderBankAgency'].patchValue(
        this.bankAccounts[0].agency
      );
      this.orderForm.controls['senderBankName'].patchValue(
        this.bankAccounts[0].bank
      );
      this.branchs = [getResult.data.cnpj];
      this.orderForm.controls['senderBranch'].patchValue(getResult.data.cnpj);
    });
  }

  setControls() {
    $(this.controlReceiverBankName).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlReceiverCountry).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlCurrency).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlSenderBranch).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlSenderBankName).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });

    let t = this;

    $(this.controlReceiverBankName).on('change', function () {
      t.changeReceiverBankName($(this).val());
    });
    $(this.controlReceiverCountry).on('change', function () {
      t.changeReceiverCountry($(this).val());
    });
    $(this.controlCurrency).on('change', function () {
      t.changeCurrency($(this).val());
    });
    $(this.controlSenderBranch).on('change', function () {
      t.changeSenderBranch($(this).val());
    });
    $(this.controlSenderBankName).on('change', function () {
      t.changeSenderBankName($(this).val());
    });
  }

  changeReceiverBankName(text: String) {
    this.orderForm.controls['receiverBankName'].patchValue(text);
  }

  changeReceiverCountry(text: String) {
    this.orderForm.controls['receiverCountry'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
    this.orderForm.controls['receiverABA'].patchValue('');
    this.orderForm.controls['receiverIBAN'].patchValue('');
    this.order.receiverCountry == 'Estados Unidos' ? this.IBAN = false : this.IBAN = true;
  }

  changeCurrency(text: String) {
    this.orderForm.controls['currency'].patchValue(text);
  }

  changeSenderBranch(text: String) {
    this.orderForm.controls['senderBranch'].patchValue(text);
  }

  changeSenderBankName(text: String) {
    this.orderForm.controls['senderBankName'].patchValue(text);
  }

  handleReceiverPersonTypePF(event) {
    var target = event.target;
    if (target.checked) {
      this.orderForm.controls['receiverPersonType'].setValue(0);
    }
  }

  handleReceiverPersonTypePJ(event) {
    var target = event.target;
    if (target.checked) {
      this.orderForm.controls['receiverPersonType'].setValue(1);
    }
  }

  sendInvoice() {
    this.loading = true;
    let order: GenerateInvoiceOutboundDto = {
      description: this.order.description,
      currency: this.order.currency,
      amount: this.order.amount,
      ABA: this.order.receiverABA,
      IBAN: this.order.receiverIBAN,
      finalityId: this.order.finalityId,
      corporateAccountId: this.order.corporateAccountId,
      sender: {
        branch: this.order.senderBranch,
        bankName: this.order.senderBankName,
        bankAgency: this.order.senderBankAgency,
        bankAccount: this.order.senderBankAccount,
      },
      receiver: {
        personType: this.order.receiverPersonType,
        name: this.order.receiverName,
        documentType: null,
        documentNumber: null,
        address: this.order.receiverAddress,
        intermediaryAccount: this.order.receiverIntermediaryAccount,
        intermediaryBank: this.order.receiverIntermediaryBank,
        intermediarySwift: this.order.receiverIntermediarySwift,
        bankChannel: this.order.receiverBankChannel,
        bankName: this.order.receiverBankName,
        country: this.order.receiverCountry,
        account: this.order.receiverAccount,
        swift: this.order.receiverSwift,
        sameUser: this.order.receiverSameUser,
      },
    };

    // this.ordersService.createOutboundOrder(order).subscribe({
    //   next: (orderResult) => {
    //     this.notifier.notify('success', 'Invoice criado com sucesso!');
    //     this.loading = false;
    //     this.closeModal();
    //     orderResult.data.finality.invoiceNeed
    //       ? this.openAttachInvoiceModal(orderResult.data.id)
    //       : this.openGenerateSuccessModal(orderResult.data.id);
    //     this.ordersService.updateOrderView();
    //   },
    //   error: (err) => {
    //     this.loading = false;
    //   },
    // });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openNewOrderOutboundModal() {
    this.modalService.dismiss(null);
    this.modalService.present(NewOrderModalOutboundComponent);
  }

  openGenerateSuccessModal(orderId: number) {
    this.modalService.dismiss(null);
    this.modalService.present(GenerateInvoiceSuccessModalComponent, orderId);
  }

  openAttachInvoiceModal(orderId: number) {
    this.modalService.dismiss(null);
    this.modalService.present(AttachInvoiceModalComponent, orderId);
  }
}
